module.exports = {
    'app.channel.list.success.delete': 'Xóa bản ghi thành công',
    'app.channel.list.error.server.msg': 'Có lỗi xảy ra:',
    

  };